import React from "react";
import { Breadcrumb, PageHeader } from "antd";
import { Link } from "react-router-dom";

const CustomBreadcrumb = (props) => {
  const { routes } = props;
  return (
    <PageHeader
      style={{
        border: "none",
      }}
      breadcrumbRender={() => <CustomBreadcrumbs routes={routes} />}
    />
  );
};

const CustomBreadcrumbs = ({ routes }) => (
  <Breadcrumb>
    {routes.map((route, index) => {
      const isLast = index === routes.length - 1;
      const linkStyle = { color: "#3e79f7", textDecoration: "none" };

      const contentStyle = isLast
        ? { ...linkStyle, fontWeight: "bold" }
        : linkStyle;

      return (
        <Breadcrumb.Item key={route.path ?? index}>
          {route.href ? (
            <Link to={route.href} style={contentStyle} aria-current={isLast ? "page" : undefined}>
              {route.breadcrumbName}
            </Link>
          ) : isLast ? (
            <span style={{ color: "#3e79f7", fontWeight: "bold" }} aria-current="page">
              {route.breadcrumbName}
            </span>
          ) : (
            <span>{route.breadcrumbName}</span>
          )}
        </Breadcrumb.Item>
      );
    })}
  </Breadcrumb>
);

export default CustomBreadcrumb;
